import { createAsyncThunk } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { actionTransitionService } from '../../services/actionTransitionService'
import { GET_ACTION_TRANSITIONS_DATA } from '../config'
import { IRequestActionParams } from '../models'
import { selectActionTransitionsLoadingStatus } from '../selectors/selectActionTransitionsData'

import { handleApiResponse } from './helpers/handleApiResponse'

class ActionTransitionApi {
  public getActionTransitions = createAsyncThunk(
    GET_ACTION_TRANSITIONS_DATA,
    async ({ requestId }: IRequestActionParams, _thunkAPI) => {
      const response = await actionTransitionService.fetchActionTransitions(requestId)
      return handleApiResponse(response)
    },
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectActionTransitionsLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )
}

export const actionTransitionApi = new ActionTransitionApi()
